import * as THREE from 'three'
import Scene from './Scene'
import Model from '@/objects/Model'
import config from '@/config/intro'
import { watch } from '@/store'

const clock = new THREE.Clock(false)

export default class IntroScene extends Scene {
  name = 'IntroScene'
  paused = true
  index = 0

  constructor (stage) {
    super()

    this.stage = stage
    this.createEnvironment()
    this.createCharacter()
  }

  createEnvironment () {
    const { path, rotation, position } = config.environment
    this.environment = new Model(path)
    this.environment.rotateY(rotation)
    this.environment.position.copy(position)
  }

  createCharacter () {
    const { path, rotation, position } = config.character
    this.character = new Model(path)
    this.character.setShadow(3, config.scene.shadow)
    this.character.rotateY(rotation)
    this.character.position.copy(position)
  }

  watchStore () {
    this.unwatch = watch('data', data => {
      if (data) {
        const { index, fragments } = data
        const { position, camera: { x, y, z } } = fragments[index].intro

        if (this.index === 0) {
          clock.getElapsedTime() // resets clock delta
        }

        this.index = index
        this.environment.position.x = -position
        this.stage.changeCameraPosition(x, y, z)
      }
    }, { immediate: true })
  }

  start () {
    const { background, fog } = config.scene
    const { x, y, z } = config.camera

    this.stage.add(this.environment)
    this.stage.add(this.character)

    this.stage.setCameraPosition(x, y, z)

    this.stage.changeBackground(background)
    this.stage.changeFogColor(fog.color)
    this.stage.changeFogDistance(fog.near, fog.far)

    this.watchStore()
    this.resume()
  }

  stop () {
    this.pause()
    this.unwatch()

    this.stage.remove(this.environment)
    this.stage.remove(this.character)

    this.environment.position.x = 0
  }

  pause () {
    clock.stop()
    this.paused = true
  }

  resume () {
    clock.start()
    this.paused = false
  }

  update () {
    if (this.paused || this.index === 0) return

    const delta = clock.getDelta()
    this.character.update(delta)
    this.environment.position.x -= delta * config.speed
  }
}
